import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";

const getLocale = ({ settingsData }) => settingsData.locale;

const ToastNotif = () => {
  const locale = useSelector(getLocale);

  return (
    <ToastContainer
      position="bottom-left"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={locale === "fa"}
      pauseOnFocusLoss
      draggable
      pauseOnHover
    />
  );
};

export default ToastNotif;
